const CreatedByMeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#CDEAFF" />
      <path
        d="M18.9165 7.66675V10.1667M11.4165 7.66675V10.1667M15.1665 7.66675V10.1667"
        stroke="#2497EB"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.8333 16.8334V14.7501C21.8333 12.0002 21.8333 10.6253 20.9791 9.77101C20.1247 8.91675 18.7498 8.91675 16 8.91675H14.3333C11.5835 8.91675 10.2085 8.91675 9.35427 9.77102C8.5 10.6253 8.5 12.0002 8.5 14.7501V18.5001C8.5 21.2499 8.5 22.6248 9.35427 23.4792C10.2085 24.3334 11.5835 24.3334 14.3333 24.3334H16.8333"
        stroke="#2497EB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8335 18.5001H15.1668M11.8335 15.1667H18.5002"
        stroke="#2497EB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.5 21.8333H21M21 21.8333H18.5M21 21.8333V24.3333M21 21.8333V19.3333"
        stroke="#2497EB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CreatedByMeIcon;
